import { render } from "./QuizResult.vue?vue&type=template&id=f5c9f95e&scoped=true"
import script from "./QuizResult.vue?vue&type=script&lang=js"
export * from "./QuizResult.vue?vue&type=script&lang=js"

import "./QuizResult.vue?vue&type=style&index=0&id=f5c9f95e&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c9f95e"]])

export default __exports__